import { useState } from 'react';

const useSwipe = (swipeDistance: number) => {
	const [touchStart, setTouchStart] = useState(null);
	const [touchEnd, setTouchEnd] = useState(null);
	const [isSwiped, setIsSwiped] = useState(false);

	const onTouchStart = (e) => {
		setTouchEnd(null);
		setTouchStart(e.targetTouches[0].clientX);
	};

	const onTouchMove = (e) => {
		if (isSwiped) return;
		setTouchEnd(e.targetTouches[0].clientX);
	};

	const onTouchEnd = () => {
		if (!touchStart || !touchEnd) return;
		const distance = touchStart - touchEnd;
		const isLeftSwipe = distance > swipeDistance;
		const isRightSwipe = distance < -swipeDistance;
		if (isLeftSwipe || isRightSwipe) setIsSwiped(true);
	};

	return [isSwiped, onTouchStart, onTouchMove, onTouchEnd] as const;
};

export default useSwipe;
